import { promoCodesUsedCollection } from "@/firebase";
import store from "@/store";

const state = {
  promoCodesUsed: []
};

const getters = {};

const actions = {
  getPromoCodesUsed({ commit }, payload) {
    return new Promise((resolve, reject) => {
      promoCodesUsedCollection
        .where("client", "==", payload.client)
        .where("uid", "==", payload.uid)
        .get()
        .then(querySnapshot => {
          let tempData = [];
          querySnapshot.forEach(doc => {
            tempData.push(doc.data().promoCodeId);
          });
          commit("getPromoCodesUsed", tempData);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });
  },
  addPromoCodeUsed({ commit }, payload) {
    promoCodesUsedCollection.add(payload).then(docRef => {
      store.dispatch(
        "getPromoCodes",
        store.state.storeClient.client.basicSettings.name
      ); // refresh aktivnih promo kod
      commit("addPromoCodeUsed", Object.assign(payload, { id: docRef.id }));
    });
  }
};

const mutations = {
  getPromoCodesUsed(state, payload) {
    state.promoCodesUsed = payload;
  },
  addPromoCodeUsed(state, payload) {
    state.promoCodesUsed.push(payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
